
import { SET_TEAMCONSISTENCY_DATA } from "../actions/action_teamconsistency";
import { SET_TEAMCONSISTENCY_INITIALDATA } from "../actions/action_teamconsistency";
import { SET_TEAMCONSISTENCY_CHARTREGISTERED } from "../actions/action_teamconsistency";

const data = {
    labels: [],
    datasets: [{
            label: "Floor",
            backgroundColor: 'rgb(6, 190, 189)',
            borderColor: 'rgb(6, 190, 189)',
            data: [],
            lineTension: 0,
            fill: false,
        },{
            label: "Phorse",
            backgroundColor: 'rgb(246, 142, 86)',
            borderColor: 'rgb(246, 142, 86)',
            data: [],
            lineTension: 0,
            fill: false,
        },{
            label: "Rings",
            backgroundColor: 'rgb(183, 206, 99)',
            borderColor: 'rgb(183, 206, 99)',
            data: [],
            lineTension: 0,
            fill: false,
        },{
            label: "Vault",
            backgroundColor: 'rgb(162, 145, 240)',
            borderColor: 'rgb(162, 145, 240)',
            data: [],
            lineTension: 0,
            fill: false,
        },{
            label: "Pbars",
            backgroundColor: '#e9e165',
            borderColor: '#e9e165',
            data: [],
            lineTension: 0,
            fill: false,
        },{
            label: "Highbar",
            backgroundColor: '#9da1a7',
            borderColor: '#9da1a7',
            data: [],
            lineTension: 0,
            fill: false,
        }]
};

const initialState = {
  tcdata: {},
  chartRegistered: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_TEAMCONSISTENCY_DATA:
      var d = {labels:[],datasets:[]};
      d.labels = action.payload.labels;
      d.datasets = data.datasets;
      d.datasets[0].data = action.payload.fxs;
      d.datasets[1].data = action.payload.phs;
      d.datasets[2].data = action.payload.srs;
      d.datasets[3].data = action.payload.vts;
      d.datasets[4].data = action.payload.pbs;
      d.datasets[5].data = action.payload.hbs;
      let newState = {
        tcdata: d,
        chartRegistered: true
      }
      return { ...state, ...newState };
    case SET_TEAMCONSISTENCY_INITIALDATA: //may not need now
      return { ...state };
    case SET_TEAMCONSISTENCY_CHARTREGISTERED:
      return { ...state, chartRegistered: action.payload };
    default:
      return state;
  }
}
